<template>
  <BreadCrumb PageTitle="Liste des Formules" />
  <ListeFormule />
</template>
  
<script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeFormule from "../../components/Formule/ListeFormule.vue";
  
  export default defineComponent({
    name: "ListeFormulePage",
    components: {
      BreadCrumb,
      ListeFormule,
    },
  });
</script>